import React, { useState } from 'react';
import { ShoppingCartIcon, UserIcon, SearchIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { SearchModal } from './SearchModal';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const {
    cartCount
  } = useCart();
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navLinkClasses = ({
    isActive
  }: {
    isActive: boolean;
  }) => `text-sm font-bold uppercase tracking-wide transition-colors ${isActive ? 'text-clinical-blue border-b-2 border-clinical-blue pb-1' : 'text-slate-900 hover:text-clinical-blue'}`;
  const mobileNavLinkClasses = ({
    isActive
  }: {
    isActive: boolean;
  }) => `block text-base font-bold uppercase tracking-wide transition-colors py-3 ${isActive ? 'text-clinical-blue' : 'text-slate-900 hover:text-clinical-blue'}`;
  return <nav className="w-full bg-white border-b border-slate-100" data-id="element-149" data-mp="9ohk9lwa3jri">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150" data-mp="9o7u9yb8hclt">
        <div className="flex justify-between h-20 sm:h-24 items-center" data-id="element-151" data-mp="emrglztqoqep">
          <Link to="/" className="flex-shrink-0" onClick={() => setMobileMenuOpen(false)} data-id="element-152" data-mp="jmx1mx5i7ent">
            <span className="text-lg sm:text-2xl font-black tracking-tight text-clinical-blue uppercase" data-id="element-153" data-mp="okfdavawo7zi">
              Daily Care Pharmacy
            </span>
          </Link>

          <div className="hidden lg:flex items-center space-x-10" data-id="element-154" data-mp="3s1xg2obtmot2">
            <NavLink to="/prescriptions" className={navLinkClasses} data-id="element-155" data-mp="3s04e3mc5ksre">
              Prescriptions
            </NavLink>
            <NavLink to="/otc-products" className={navLinkClasses} data-id="element-156" data-mp="5mmbxxfxk648">
              OTC Products
            </NavLink>
            <NavLink to="/services" className={navLinkClasses} data-id="element-157" data-mp="34do228kun5ch">
              Services
            </NavLink>
            <NavLink to="/locations" className={navLinkClasses} data-id="element-158" data-mp="39axqpm0ezcz9">
              Locations
            </NavLink>
          </div>

          <div className="flex items-center space-x-2 sm:space-x-5" data-id="element-159" data-mp="319gn0zzrwdtg">
            <button onClick={() => setSearchOpen(true)} className="p-2 text-slate-400 hover:text-clinical-blue transition-colors" data-id="element-160" data-mp="2wb5dkqde45br">
              <SearchIcon className="w-5 h-5" data-id="element-161" data-mp="3629mp9gdwvyo" />
            </button>
            <Link to="/cart" className="p-2 text-slate-400 hover:text-clinical-blue transition-colors relative" data-id="element-162" data-mp="3642vovegzs9u">
              <ShoppingCartIcon className="w-5 h-5" data-id="element-163" data-mp="2deduoi1rfs88" />
              {cartCount > 0 && <span className="absolute top-1 right-1 w-4 h-4 bg-clinical-blue text-white text-[10px] font-bold rounded-full flex items-center justify-center" data-id="element-164" data-mp="2sav5n861f4u9">
                  {cartCount}
                </span>}
            </Link>
            <button className="lg:hidden p-2 text-slate-400 hover:text-clinical-blue transition-colors" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-165" data-mp="7mguyw2oyst7">
              {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-166" data-mp="f3lpjcbrg837" /> : <MenuIcon className="w-6 h-6" data-id="element-167" data-mp="f1sku2kpjxxu" />}
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence data-id="element-168" data-mp="55pfknuk7j6o">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden border-t border-slate-100 bg-white overflow-hidden" data-id="element-169" data-mp="567lydaxrdsb">
            <div className="px-4 py-6 space-y-4" data-id="element-170" data-mp="o38sw3o1vnyw">
              <NavLink to="/prescriptions" className={mobileNavLinkClasses} onClick={() => setMobileMenuOpen(false)} data-id="element-171" data-mp="1bu5tikaeayuu">
                Prescriptions
              </NavLink>
              <NavLink to="/otc-products" className={mobileNavLinkClasses} onClick={() => setMobileMenuOpen(false)} data-id="element-172" data-mp="3p2ynv93hfcrd">
                OTC Products
              </NavLink>
              <NavLink to="/services" className={mobileNavLinkClasses} onClick={() => setMobileMenuOpen(false)} data-id="element-173" data-mp="3f411abpm9tb0">
                Services
              </NavLink>
              <NavLink to="/locations" className={mobileNavLinkClasses} onClick={() => setMobileMenuOpen(false)} data-id="element-174" data-mp="6nxue86bw8nq">
                Locations
              </NavLink>
              <div className="pt-4 border-t border-slate-100" data-id="element-175" data-mp="3u1tj5aimytsd">
                <button className="flex items-center gap-3 text-slate-500 hover:text-clinical-blue font-bold uppercase tracking-wide text-sm py-2" data-id="element-176" data-mp="3tz78v34d206g">
                  <UserIcon className="w-5 h-5" data-id="element-177" data-mp="plqxpbkv6kln" /> Sign In / Register
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>

      <SearchModal isOpen={searchOpen} onClose={() => setSearchOpen(false)} data-id="element-178" data-mp="2d7v2liyxzm2u" />
    </nav>;
}